export const HOME_PAGE_ROUTE = `/`;
export const NEW_PAGE_ROUTE = `/new`;

export const SUMMARY_PAGE_PARAM = 'textId';
export const SUMMARY_PAGE_ROUTE = `/s/:${SUMMARY_PAGE_PARAM}`;

export const SEARCH_PAGE_ROUTE = '/search';
